import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "HR Foundations & Organizational Structure",
    description:
      "HR role & importance in organizations, Functions of HR: hiring training payroll compliance, Organizational hierarchy & culture, Workforce planning & manpower forecasting, Real examples of HR impact on companies",
  },
  {
    title: "Recruitment, Talent Acquisition & Hiring Strategies",
    description:
      "Job description creation & requirement mapping, Talent sourcing: LinkedIn job portals referrals, Screening shortlisting & interview rounds, Behavioral interviews & competency-based hiring, Reducing hiring bias & improving candidate experience",
  },
  {
    title: "JavaScript Onboarding, Employee Engagement & Workplace Culture",
    description:
      "Designing structured onboarding programs, Employee motivation strategies, Engagement activities & communication frameworks, Creating positive workplace culture, Retention techniques to reduce attrition",
  },
  {
    title: "Training, Development & Performance Management",
    description:
      "Identifying skill gaps & training needs, Learning & development (L&D) strategies, Performance reviews KPIs & goal setting, 360-degree feedback system, Building high-performance teams",
  },
  {
    title: "Payroll, Compensation & HR Operations",
    description:
      "Salary structure components (CTC gross net), Payroll processing & compliance, Incentives bonuses & benefits management, Attendance leaves & shift management, HR documentation & audit readiness",
  },
  {
    title: "Labor Laws, Compliance & Workplace Policies",
    description:
      "Industrial & labor laws (Indian context), Company policies: leave code of conduct POSH, PF ESIC gratuity & statutory compliance, Employment contracts & legal frameworks, Ensuring safe & compliant workplaces",
  },
  {
    title: "HR Analytics, Reporting & Decision Making",
    description:
      "Using data for human resource planning, Attrition analysis performance metrics & hiring analytics, HR dashboards & reporting tools, Predictive HR analytics (basic), Making data-driven HR decisions",
  },
  {
    title: "Conflict Management, Ethics & Employee Relations",
    description:
      "Handling workplace conflicts calmly, Negotiation & mediation strategies, Employee grievances & counseling, Ethics diversity & inclusion, Building trust between management & staff",
  },
  {
    title: "HR Technology, Tools & Automation",
    description:
      "HRMS platforms: Keka Zoho DarwinBox BambooHR, Attendance automation payroll systems & digital onboarding, Using AI tools for recruitment, Applicant Tracking Systems (ATS), Future of HR tech & digital transformation",
  },
  {
    title: "Capstone HR Project & Career Launchpad",
    description:
      "Designing a recruitment/HR strategy project, Creating HR reports & presentation decks, Portfolio development for HR roles, Resume building & LinkedIn branding, Interview prep for HR Executive HR Manager & Talent Acquisition roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
